import Link from 'next/link'
import { Card, device, space } from '@ticketswap/solar'
import { generateImagePlaceholder } from '~/utils/generateImagePlaceholder'
import { track } from '~/utils/analytics'
import {
  EXPLORE_NEARBY_LOCATION_TAPPED,
  EXPLORE_NEARBY_LOCATION_VIEWED,
} from '~/lib/tracking-events'
import { decodeGlobalId } from '~/utils/id'
import { RouteMap } from '~/lib/routeMap'
import { Skeleton } from './Skeleton'
import styled from '@emotion/styled'
import ViewportTracking from '~/components/ViewportTracking'

const LocationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${space[8]};
  margin-block-start: ${space[16]};

  @media ${device.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const NearbyLocations = ({ loading, locations }) => {
  const handleTracking = async location =>
    await track(EXPLORE_NEARBY_LOCATION_TAPPED, {
      location,
    })

  if (loading)
    return (
      <LocationsGrid>
        <Skeleton amount={6} height={space[144]} />
      </LocationsGrid>
    )

  return (
    <ViewportTracking
      event={EXPLORE_NEARBY_LOCATION_VIEWED}
      payload={{
        locations,
      }}
    >
      <LocationsGrid>
        {locations.map(location => (
          <Link
            key={location.id}
            prefetch={false}
            href={{
              pathname: RouteMap['LOCATION'],
              query: {
                slug: location.slug,
                id: decodeGlobalId(location.id),
              },
            }}
            passHref
          >
            <button as="a" onClick={() => handleTracking(location)}>
              <Card
                image={location.image || location.background || generateImagePlaceholder(100, 100)}
                title={location.name}
              />
            </button>
          </Link>
        ))}
      </LocationsGrid>
    </ViewportTracking>
  )
}

export default NearbyLocations
